<template>
	<div style="background: #F6F6F6;padding-bottom: 50px;position: relative;">
		<div class="wrap">
			<div class="left">
				<div class="left-top-user" id="step1">
					<div class="toux">
						<div>
							<img src='../../assets/images/avatar.png' alt="">
						</div>
					</div>
					<p style="margin-top: 15px;text-align: center;">{{$store.state.companyInfo.name}}</p>
					<p style="margin-top: 15px;text-align: center;">{{$store.state.userInfo.nickname}},欢迎您</p>
					<div class="qiehuan" @click="$router.push(`/userCenter`)">
						切换为个人管理
					</div>
				</div>
				<div class="body-left">
					<div @click="goto(`/companyCenter/companyProperty`)" style="background: #E5EDFB;height: 60px;display: flex;align-items: center;padding: 0 20px; box-sizing: border-box;margin-bottom: 12px;cursor: pointer;">
						<img src='../../assets/images/bill.png' alt="">
						<span style="color: #0052d9;margin-left: 10px;font-size: 18px;">财务与资产</span>
					</div>
					<div class="body-left-item">
						<el-collapse v-model="activeNames" @change="handleChange" class="collapse">
							<el-collapse-item name="1">
								<template slot="title">
									<img src='../../assets/images/order.png' style="width: 18px;height: 20px;"
										alt=""><span style="margin-left: 8px;">订单</span>
								</template>
								<div class="collapse-inner">
									<p @click="goto(`/companyCenter/backlog`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										进行中
									</p>
									<p @click="goto(`/companyCenter/ordeHistory`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										历史订单
									</p>
								</div>

							</el-collapse-item>
							<el-collapse-item name="2">
								<template slot="title">
									<img src='../../assets/images/flyicon.png' style="width: 19px;height: 19px;" alt="">
									<span style="margin-left: 8px;">平台活动</span>
								</template>
								<div class="collapse-inner">
									<p @click="goto(`/companyCenter/projectNeed`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										项目需求
									</p>
									<p @click="goto(`/companyCenter/resourceTools`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										资源工具
									</p>
									<p @click="goto(`/companyCenter/solution`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										解决方案
									</p>
									<p @click="goto(`/companyCenter/productService`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										产品服务
									</p>
									<p @click="goto(`/companyCenter/seekHelp`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										求助应助
									</p>

								</div>

							</el-collapse-item>
							<el-collapse-item name="3">
								<template slot="title">
									<img src='../../assets/images/team.png' style="width: 22px;height: 18px;" alt="">
									<span style="margin-left: 8px;">组织与管理</span>
								</template>
								<div class="collapse-inner">
									<p  @click="goto(`/companyCenter/Department`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										创建和管理部门
									</p>
									<p @click="goto(`/companyCenter/position`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
									margin: 15px;cursor: pointer;font-size: 16px;">
										创建和管理岗位
									</p>
								</div>

							</el-collapse-item>
							
							<div id="step2">
								<el-collapse-item name="4">
									<template slot="title">
										<img src='../../assets/images/xiaoxi.png' style="width: 20px;height: 18px;"
											alt="">
										<span style="margin-left: 8px;">消息</span>
									</template>
									<div class="collapse-inner">
										<p @click="goto(`/companyCenter/message`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
										margin: 15px;cursor: pointer;font-size: 16px;">
											站内信
										</p>
										<p @click="goto(`/companyCenter/message`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
										margin: 15px;cursor: pointer;font-size: 16px;">
											系统消息
										</p>
										<p @click="goto(`/companyCenter/accountSet`)" style="font-size: 16px;font-family: PingFang;font-weight: 400;
										margin: 15px;cursor: pointer;font-size: 16px;">
											账号设置
										</p>
									</div>

								</el-collapse-item>

							</div>

						</el-collapse>
					</div>

				</div>
			</div>
			<router-view></router-view>

			<div class="body-right" v-if="!$route.meta.noRight">
				<div @click="dialogVisible = true">
					<img src='../../assets/images/zhifly.png' alt="" style="width: 18px;height: 18px;"><span
						style="width:80px">发布</span>
				</div>
				<div style="background: #18BC9C;" @click="goto(`/companyCenter/drafts`)">
					<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;"><span
						style="width:80px">草稿箱</span>
				</div>
				<div style="background:#0297F8;" @click="dialogVisible2 = true">
					<img src='../../assets/images/dwen.png' alt="" style="width: 19px;height: 19px;"><span
						style="width:80px">求助</span>
				</div>
				<!-- <div style="background:#444C69;" @click="goto(`/companyCenter/message`)">
					<img src='../../assets/images/iicon.png' alt="" style="width: 18px;height: 16px;"><span
						style="width:80px">@我的</span>
				</div> -->
				<!-- <div style="background:#E5F2FF; color: black;" @click="goto(`/companyCenter/message`)">
					<img src='../../assets/images/xiaoxxi.png' alt="" style="width: 18px;height: 16px;"><span
						style="width:80px">我的消息</span>
				</div> -->
			</div>
			<el-dialog title="请选择栏目" :visible.sync="dialogVisible" center width="700px" top="40vh" :lock-scroll="false">
				<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
					<div @click="goto(`/projectNeed/releaseNeed`)"
						style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
						项目需求池
					</div>
					<div @click="goto(`/zyTools/createTools`)"
						style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
						资源工具池
					</div>
					<div @click="goto(`/solutionDetail/releaseSolution`)"
						style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
						解决方案池
					</div>
					<div @click="goto(`/productService/createProductService`)"
						style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
						产品服务池
					</div>
				</div>

			</el-dialog>
			<el-dialog title="请选择栏目" :visible.sync="dialogVisible2" center width="700px" top="40vh"
				:lock-scroll="false">
				<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
					<div @click="goto(`/zyTools/createTools`)"
						style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
						资源工具池
					</div>
					<div @click="goto(`/solutionDetail/createQz`)"
						style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
						解决方案池
					</div>
					<div @click="goto(`/productService/proCreateQz`)"
						style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
						产品服务池
					</div>
				</div>

			</el-dialog>
		</div>

	</div>
</template>

<script>
	export default {

		data() {
			return {
				dialogVisible: false,
				dialogVisible2: false,
				activeNames: ['1', '2', '3', '4'],

				//对话框1

			}
		},

		mounted() {

		},
		methods: {
			gowhere(e) {
				console.log(e);
			},
			goto(url) {
				this.$router.push(url)
			},

			gotologin() {
				this.$router.push({
					path: '/login'
				})
			},
			handleChange(val) {
				console.log(val);
			},
			cc(row, column, cell, event) {
				console.log(row, column.label, cell, event);
			},

		}
	}
</script>
<style>
	.el-form-item__label {
		color: black;
		font-size: 18px;
	}

	.my-button-class {
		background: #0052D9;
		color: white;
		height: 30px;
		width: 80px;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
	}

	.hasBorder {
		border: 1px solid #D2D2D2;
		width: 100%;
	}

	.zhezhaoNeo {
		position: absolute;
		background: transparent;
		width: 1100px;
		height: 330px;
		z-index: 999;
		left: 0;
		top: 20px;
	}

	.zhezhaoThree {
		position: absolute;
		background: transparent;
		width: 900px;
		height: 100px;
		z-index: 999;
		right: 300px;
		top: -100px;
	}

	.introjs-skipbutton {
		display: none !important;
	}
</style>
<style scoped lang="less">
	/deep/.el-dialog__footer {
		padding-top: 0;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50px;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}

	.leimu {
		cursor: pointer;
		text-align: center;
		width: 100px;
		height: 40px;
		border: 1px solid #D2D2D2;
	}

	.main-iteml {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
		margin: 13px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
	}

	.main-item-pic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;

	}

	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}

	.body-mid-main {
		display: flex;
		flex-wrap: wrap;

		justify-content: space-around;
	}


	.body-person-item {
		width: 151px;
		height: 270px;
		background: url('../../assets/images/personBg.png') no-repeat;
		background-position: center bottom;
		background-size: contain;

		& p {
			margin-top: 6px;
			font-size: 18px;
		}
	}

	.body-person {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: center;
	}

	.page-last-body {
		padding: 40px 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.page-last-top {
		display: flex;
		justify-content: space-between;
	}

	.huanyih {
		font-size: 18px;
		width: 110px;
		height: 40px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		text-align: center;
		cursor: pointer;
		line-height: 40px;
		margin-right: 20px;
	}

	.page-last-title {

		width: 120px;
		height: 40px;
		background: #0052D9;
		border-radius: 0px 20px 20px 0px;
		color: white;
		font-size: 22px;
		font-family: PingFang;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}

	.page-last {

		width: 100%;
		height: 450px;
		background: #FFFFFF;
	}

	/deep/.selects {
		margin-left: 15px;

		.el-input__inner {
			color: black;
			width: 100%;
		}

		.el-input__inner::placeholder {
			color: black;
		}

		color: black;
		width:95px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #D2D2D2;
	}

	.body {
		padding: 15px;
		box-sizing: border-box;
		width: 100%;

		.body-item {
			margin-top: 15px;
			display: flex;
			align-items: center;

			.kaitou {
				width: 40px;
				height: 40px;
				background: #EEEEEE;
				font-size: 24px;
				text-align: center;
				line-height: 40px;
			}
		}
	}

	.form {
		box-sizing: border-box;
		width: 100%;

		.main {
			margin: 20px 0;
			display: flex;
			flex-wrap: wrap;

			.main-item {
				cursor: pointer;
				margin-left: 15px;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 140px;
				height: 44px;
				border: 1px solid #D2D2D2;

				img {
					margin-right: 8px;
				}
			}
		}

		.inp {
			align-items: center;
			display: flex;
			font-size: 18px;
			font-family: PingFang;
			font-weight: 500;

			span {
				width: 72px;
				color: #222222;
			}

			input {
				font-size: 18px;

				flex: 1;
				margin-left: 15px;
				box-sizing: border-box;
				padding-left: 10px;
				width: 500px;
				height: 47px;
				background: #F6F6F6;
			}
		}
	}

	/deep/ .introjs-skipbutton {
		display: none;
	}

	/deep/.el-dialog__title {
		font-size: 20px;
		font-weight: bold;
	}



	/deep/ .el-select__caret {
		color: black !important;
	}

	/deep/#selectInp::placeholder {
		color: black !important;
	}

	/deep/.el-input__inner {
		border: none;
		// width: 120px;
	}

	/deep/.el-checkbox {
		display: inline;
		color: #222222;


	}

	.el-dropdown-link {
		cursor: pointer;
		color: black;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}



	.pointer {
		p {
			cursor: pointer;
			margin-bottom: 3px;
		}

		p:hover {
			color: #0052D9;
		}
	}

	.loading {
		cursor: pointer;
		width: 116px;
		height: 40px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		margin: 10px;
		margin-bottom: 0;
		justify-content: center;
	}

	.body-title {
		color: #0052D9;
		display: flex;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;

		.line {
			width: 4px;
			height: 22px;
			background: #0052D9;
		}
	}



	// is-leaf el-table__cell
	/deep/.el-table__cell {
		text-align: center;
		color: #222222;
	}

	/deep/.el-table th.el-table__cell.is-leaf {
		background: #E5EDFB;
		color: #222222;
		border: 1px solid white;
		border-top: none;
	}



	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}

	.body-left-item-foot {
		border-top: 1px solid #EEEEEE;
		display: flex;
		justify-content: space-between;
		padding: 15px;
	}

	/deep/.el-icon-arrow-right:before {
		background: white;
		border-radius: 50%;
		color: #0052D9;
	}

	.collapse-inner {
		padding: 10px;
	}
	.collapse-inner>p:hover{
		color: #0052D9;
	}

	.checkbox-wrap {
		display: flex;
		justify-content: space-around;
	}

	/deep/.el-checkbox {
		color: #222222;
		display: inline-block;
		position: relative;
	}

	.body-left {
		width: 260px;

	}

	.body-left/deep/.el-collapse-item__header {
		background: #0052D9;
		height: 55px;
		font-size: 18px;
		color: white;
		padding: 0 20px;
	}

	.left {
		.left-top-user {
			.qiehuan {
				margin: 0 auto;
				margin-top: 15px;
				width: 210px;
				height: 46px;
				background: #E5EDFB;
				color: #0052D9;
				text-align: center;
				cursor: pointer;
				line-height: 46px;
			}

			width: 260px;
			height: 291px;
			background: #FFFFFF;
			padding: 30px 25px;
			box-sizing: border-box;
			margin-bottom: 15px;

			.toux {
				display: flex;
				justify-content: center;

				&>div {
					width: 106px;
					height: 106px;
					overflow: hidden;
					border-radius: 50%;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}

	.wrap {
		position: relative;
		display: flex;
		padding-top: 20px;
		box-sizing: border-box;
	}
</style>